<div mat-dialog-content>
    <div class="body-container">
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
    </div>
    <div class="footer">
        <button type="button" mat-stroked-button mat-dialog-close="false"
                (click)="userResponseHandler(false)">
            {{ cancelBtnText }}
        </button>
        <button type="button" mat-raised-button color="primary" mat-dialog-close="true"
                (click)="userResponseHandler(true)">
            {{ continueBtnText }}
        </button>
    </div>
</div>